<a href="/producer" class="d-flex align-items-center text-nowrap text-decoration-none text-grad fs-5">
    Olá, {{ producerName }}
</a>